import { TableCell, TableHead, TableRow } from "@mui/material";

export const EnhancedTableHead = ({ columns }) => {
  return (
    <TableHead className="table-head">
      <TableRow>
        {columns.map(({ id, numeric, label, size, HeaderCell, textCenter = false, isSticky }) => (
          <TableCell
            key={id}
            align={textCenter ? "center" : numeric ? "right" : "left"}
            className={`table-head-cell ${isSticky ? "sticky" : ""}`}
            sx={{
              minWidth: size,
              padding: "10px",
            }}
          >
            {HeaderCell ? <HeaderCell /> : label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
